import type CompanyLeadState from "..";
import {Action} from "../../../action/action";

export class Next extends Action<"NEXT_STATE", undefined> {
  readonly type = "NEXT_STATE";
  protected state: CompanyLeadState;

  constructor(state: CompanyLeadState, data?: undefined) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    //TODO: what else should be here?
    return this.isDoable();
  }

  /**
   *
   * @returns - wheather the user can go to next state
   *
   * Business logic:
   * If the user picks a "OneTime" booking, they need to choose
   * goal (implicit) and a servicetype. If set, they can go to the calendar state.
   *
   * If they picked a "lead", they can to set which companysettings, they wish but
   * they don't have to in order to go to the final detail step,
   * that creates a podio task for us to contact them.
   */
  public isDoable(): boolean {
    const {product, serviceType, goal} = this.state.bookingflowStateMachine.getData();
    if (product.type === "Booking") {
      const isRequiredValuesSet = this.allHasValues(serviceType, goal);
      return isRequiredValuesSet;
    } else {
      return true;
    }
  }
}
